<script setup lang="ts">
import { RouterLink } from 'vue-router'

export interface BreadcrumbItem {
  label: string
  to?: string
}

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>

<template>
  <nav aria-label="Breadcrumb" class="breadcrumbs">
    <ol class="breadcrumbs__list">
      <li>
        <RouterLink to="/" class="breadcrumbs__link">Home</RouterLink>
      </li>
      <li v-for="(item, index) in items" :key="item.label" class="breadcrumbs__item">
        <span class="breadcrumbs__sep" aria-hidden="true">/</span>
        <RouterLink
          v-if="item.to && index < items.length - 1"
          :to="item.to"
          class="breadcrumbs__link"
        >
          {{ item.label }}
        </RouterLink>
        <span v-else class="breadcrumbs__current" aria-current="page">{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<style scoped>
.breadcrumbs {
  padding: var(--space-4) 0;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}

.breadcrumbs__list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumbs__link {
  color: var(--color-primary);
}

.breadcrumbs__sep {
  margin: 0 var(--space-1);
  color: var(--color-border-strong);
}

.breadcrumbs__current {
  color: var(--color-text-muted);
}
</style>
